"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KonfektionierungProperties = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const ArticleProperties_1 = require("../ArticleProperties");
/**
 * Konfektionierung properties that are used by the individual applications.
 */
class KonfektionierungProperties {
}
exports.KonfektionierungProperties = KonfektionierungProperties;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE;
KonfektionierungProperties[_a] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
KonfektionierungProperties[_b] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
//# sourceMappingURL=KonfektionierungProperties.js.map